const defaultSetting = {
  companyName: '楼盘网长沙有限公司',
  title: '好房云管理系统',
  apiBaseURL: process.env.NODE_ENV === 'production' ? process.env.VUE_APP_MATSTER_PATH : process.env.VUE_APP_MATSTER_PATH ,
  // 请求超时时长，单位：毫秒
  timeout: 10 * 1000,
  // 接口请求返回错误时，弹窗的持续时间，单位：毫秒
  modalDuration: 3 * 1000,
  COS_REGION: 'ap-guangzhou',
  COS_BUCKET: 'saas-crm-1303241469',
  importTemplateUrl: 'https://saas-crm-1303241469.cos.ap-guangzhou.myqcloud.com/template/%E5%91%98%E5%B7%A5%E6%89%B9%E9%87%8F%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx',
  importProTemplateUrl: 'https://saas-crm-img.loupanstatic.cn/module/%E9%A1%B9%E7%9B%AE%E6%89%B9%E9%87%8F%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF2.xlsx',
  sourceUrl: 'https://saas-crm-img.loupanstatic.cn/',
  sourceTemplateUrl: 'https://saas-crm-img.loupanstatic.cn',
  sourcePoster: 'https://saas-crm-1303241469.cos.ap-guangzhou.myqcloud.com/',
  superAdminId: 1000
}

export default defaultSetting;
export const configKeys = {
  admin_status: 'admin_status', //员工状态
  agency_types: 'agency_types', //代理模式
  business_follow_up_status: 'business_follow_up_status', //商机阶段状态
  check_status: 'check_status', //审核状态
  contract_status: 'contract_status', //合同状态
  create_types: 'create_types', //创客渠道
  customer_channels: 'customer_channels', //来源渠道
  customer_offline_channels:'customer_offline_channels',//线下来源渠道
  customer_follow_up_stage_all: 'customer_follow_up_stage_all', //客户跟进状态
  customer_follow_up_stage_completed: 'customer_follow_up_stage_completed', //客户已完成跟进状态
  customer_follow_up_stage_incomplete: 'customer_follow_up_stage_incomplete', //客户未完成跟进状态
  customer_levels: 'customer_levels', //客户等级
  customer_locations: 'customer_locations', //客户当前所在地
  customer_qualifications: 'customer_qualifications', //客户购房资质
  customer_sources: 'customer_sources', //客户来源方式
  customer_status: 'customer_status', //客户状态
  customer_terminals: 'customer_terminals', //来源终端
  decorations: 'decorations', //装修情况
  shift_public_reason: 'shift_public_reason', //转入公客池原因
  shift_invalid_reason: 'shift_invalid_reason', //转入无效池原因
  shift_black_reason: 'shift_black_reason', //转入黑名单原因
  follow_up_custom_ways: 'follow_up_custom_ways', //跟进方式-普通
  follow_up_sys_ways: 'follow_up_sys_ways', // 跟进方式-系统
  follow_up_types: 'follow_up_types', //跟进类别
  house_types: 'house_types', //物业类型
  message_types: 'message_types', //公告类型
  operation_models: 'operation_models', //操作对象
  operation_operates: 'operation_operates', //操作类型
  order_status: 'order_status', //订单状态
  orientations: 'orientations', //朝向
  pay_types: 'pay_types', //付款方式
  rooms: 'rooms', //房屋户型
  status_change_type : 'status_change_type', //放入类型 新客还是旧客
  dept_categories: 'dept_categories', //部门属性
  approval_handle_status: 'approval_handle_status', // 审批状态
  project_coop_status:'project_coop_status',//项目合作状态
  follow_up_all_ways: 'follow_up_all_ways',
  lock_status: 'lock_status',
  public_put_type: 'public_put_type',
  task_settings: 'task_settings',
  admin_join_status_search: 'admin_join_status_search',
  admin_join_type: 'admin_join_type',
  admin_join_status: 'admin_join_status',
  sem_channel: 'channel_types',
  platform_types: 'platform_types',
  private_article_type: 'private_article_type', // 经纪人素材类型
  article_type: 'article_type', // 门店文章类型
  resident_grab_type: 'resident_grab_type', // 获客方式
  customer_route_type: 'customer_route_type', //客户跟进类型
  order_route_type: 'order_route_type',
  distribute_log_type: 'distribute_log_type',
  customer_online_channels: 'customer_online_channels',
  customer_levels_for_create: 'customer_levels_for_create', // 客户等级新增（不包含未知）
}
export function getPageTitle(pageTitle) {
  if (pageTitle) {
    return `${pageTitle} - ${defaultSetting.title}`
  }
  return `${defaultSetting.title}`
}
